import React from 'react';
import { clsx, multiply, createUseStyles } from '@pushpay/styles';
import { getColors, shimmerAnimation } from './shared';
const useStyles = createUseStyles(theme => {
  const {
    baseColor,
    shimmerColor,
    lighterShimmerColor
  } = getColors(theme);
  const chartGutter = '3em';
  const axisLabelStyles = {
    content: '""',
    position: 'absolute',
    left: 0,
    width: '2.5em',
    height: '1em',
    borderRadius: '1em',
    transform: `translate(-${chartGutter}, -50%)`
  };
  return {
    root: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      padding: `0 ${chartGutter} 0 ${multiply(chartGutter, 2)}`,
      zIndex: 0
    },
    lines: {
      width: '25%',
      transform: 'rotate(45deg)',
      animation: '$shimmer 2s infinite'
    },
    line: {
      height: '50%',
      background: 'transparent',
      border: `0 solid ${shimmerColor}`,
      '&:first-child': {
        borderRightWidth: '3px',
        borderBottomWidth: '3px'
      },
      '&:last-child': {
        borderLeftWidth: '3px'
      }
    },
    background: {
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: -1
    },
    axis: {
      position: 'relative',
      height: '1px',
      backgroundColor: theme.colors['palette-grey-light-200'],
      width: `calc(100% - ${chartGutter})`,
      '&:before': { ...axisLabelStyles,
        backgroundColor: baseColor
      },
      '&:after': { ...axisLabelStyles,
        opacity: 0,
        backgroundColor: lighterShimmerColor,
        animation: '$shimmer 2s infinite'
      }
    },
    ...shimmerAnimation
  };
});
export const SkeletonLineChart = props => {
  const {
    classes: classesProp,
    className: classNameProp,
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: classes.lines
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.line
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.line
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.background
  }, Array(5).fill(null).map((_, index) => {
    const key = `axis-${index}`;
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: classes.axis
    });
  })));
};